import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import VideoModal from "@/ts/components/elements/video-modal.vue";
import UniversalVideo from "@/ts/components/elements/universal-video.vue";

interface Props {
    videoUrl: string;
    subtitle: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'intro-video-button',
  props: {
    videoUrl: { type: String, required: true },
    subtitle: { type: String, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

let show = ref(false);

const modal = ref({ open: false });



const __returned__ = { get show() { return show }, set show(v) { show = v }, modal, VideoModal, UniversalVideo }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})